export default __webpack_public_path__ + "static/media/new_main_white_right_arrow.8325861e.svg";